
import React from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import PropTypes from 'prop-types';
import { pt} from '../../../components/utiles';
import { JDText, JDModal, JDTouchable } from '@jdreact/jdreact-core-lib';

const Alert = (props) => {
    return (
        <JDModal visible={props.show} transparent={true} style={styles.modalContainer}>
            <View style={styles.container}>
                <View style={styles.content}>
                    <JDText style={styles.title}>{props.title}</JDText>
                    <View style={styles.btnGroup}>
                        <JDTouchable onPress={() => {
                            props.onCancel && props.onCancel();
                        }} >
                            <View style={styles.cancelBtn}>
                                <JDText style={styles.cancelBtnText}>{props.cancelBtnText || '取消'}</JDText>
                            </View>
                        </JDTouchable>
                        <JDTouchable onPress={() => {
                            props.onConfirm && props.onConfirm();
                        }}>
                            <View style={styles.confirmBtn}
                            >
                                <JDText style={styles.confirmBtnText}>{props.cancelBtnText || '确认'}</JDText>

                            </View>
                        </JDTouchable>

                    </View>
                </View>

            </View>

        </JDModal>
    );
};

export default Alert;

Alert.prototype = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    cancelBtnText: PropTypes.string,
    confirmBtnText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
};

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'green',
        zIndex: 999
    },
    content: {
        backgroundColor: '#fff',
        borderRadius: pt(24),
        width: pt(600),
        minHeight: pt(287),
        padding: pt(48),
        paddingTop: pt(64),
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    title: {
        fontSize: pt(32),
        fontWeight: 'bold'
    },
    btnGroup: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: pt(72)
    },
    cancelBtn: {
        width: pt(220),
        height: pt(60),
        borderRadius: pt(70),
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    cancelBtnText: {
        fontSize: pt(28),
        color: '#262626'
    },
    confirmBtnText: {
        fontSize: pt(28),
        color: '#fff'
    },
    confirmBtn: {
        backgroundColor: '#FA2C19',
        width: pt(220),
        height: pt(60),
        borderRadius: pt(30),
        borderColor: '#FA2C19',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
});
